<template>
  <transition name="fade">
    <v-btn
      v-if="modelIsAddable"
      class="ml-3 elevation-2"
      color="green accent-4"
      left
      bottom
      dark
      fab
      x-small
      aria-label="Add a New Record"
      @click="$emit('add')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </transition>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'ManageBaseTableFooterAddBtn',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapFields('admin', { modelIsAddable: 'tableConfig.addable' }),
  },
}
</script>

<style lang="scss" scoped></style>
